import React, { useState, useEffect } from "react";
import { PaginaCarga } from "../../Componentes/Compuestos/Paginas/PaginaCarga";
import { function_VEN_Reservas_Cabecera_Leer } from "neftis7_apicaller/src/funciones/VEN/Reservas/VEN_Reservas_Cabecera";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";
import { NumberBox } from "devextreme-react";
import { VEN_Reservas_ParticipantesPorItem } from "../../Componentes/Compuestos/Complejos/Operaciones/VEN_Reservas_ParticipantesPorItem";
import { LVForm } from "../../Componentes/Basicos/LVForm";
import { SimpleItem } from "devextreme-react/form";
import { FormateoFechaPara_ddMMyyyy_HHmm } from "neftis7_apicaller/src/funciones/Varios";
import { useParams } from "react-router-dom";

export const VEN_Reservas_CheckIn = () => {
  const [loading, setLoading] = useState(false)
  const [idReserva, setIdReserva] = useState(0);
  const [idClienteResponsable, setIdClienteResponsable] = useState(0);
  const [reserva, setReserva] = useState([]);
  const [detalles, setDetalles] = useState([]);
  const params = useParams();
  const [copiado, setCopiado] = useState(false);

  useEffect(() => {
    if (params?.idReserva) {
      setIdReserva(Number(params.idReserva));
      handleBuscarReserva(Number(params.idReserva));
    }
  }, [params]);

  const handleIdReservaOnValueChanged = (e) => {
    setIdReserva(e.value)
  }

  const handleBuscarReserva = async (idReserva) => {
    try {
      if (!idReserva || idReserva < 1) {        
        setReserva([]);
        setDetalles([]);
        setIdClienteResponsable(0);
        setIdReserva(0)
        alert("Para buscar necesita ingresar una reserva con número válido.");
        return;
      }

      setLoading(true);
      const resultReserva = await function_VEN_Reservas_Cabecera_Leer(idReserva);

      if (resultReserva.data.IdEstado == 50) {
        setReserva([]);
        setDetalles([]);
        setIdClienteResponsable(0);
        setIdReserva(0)
        alert("Para buscar necesita ingresar una reserva facturada.");
        return;
      }

      if (resultReserva.data.IdEstado == -10) {
        setReserva([]);
        setDetalles([]);
        setIdClienteResponsable(0);
        setIdReserva(0)
        alert("Para buscar necesita ingresar una reserva que no se encuentre anulada.");
        return;
      }

      setReserva(resultReserva.data || []);
      setDetalles(resultReserva.data.Detalles || []);
      setIdClienteResponsable(resultReserva.data.IdClienteGenerador);
    } catch (error) {
      alert("Hubo problemas con la Reserva.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <PaginaCarga
      Titulo="CHECK IN"
    >
      <LVForm colCount={10} >
        <SimpleItem>
          <NumberBox
            label="Reserva"
            value={idReserva}
            width={120}
            onValueChanged={handleIdReservaOnValueChanged}

            style={{ flex: 1, marginRight: '10px' }}
          />
        </SimpleItem>
        <SimpleItem>
          <LVButtonAccion
            Texto="BUSCAR"
            Ancho={200}
            onClick={() => handleBuscarReserva(idReserva)}
            style={{ flex: 1 }}
          />
        </SimpleItem>

        <SimpleItem>

        </SimpleItem>
        <SimpleItem>

        </SimpleItem>

        <SimpleItem>

        </SimpleItem>
        <SimpleItem>

        </SimpleItem>

        <SimpleItem>

        </SimpleItem>
        <SimpleItem>

        </SimpleItem>

        <SimpleItem>

        </SimpleItem>
        <SimpleItem>

        </SimpleItem>

        <SimpleItem colSpan={10}>
          <div>

            <hr style={{ borderColor: 'white', borderWidth: '1px' }} />
            <hr style={{ borderColor: 'white', borderWidth: '1px' }} />

            {loading ? (
              <div className="spinner-border" role="status">
                <span className="sr-only">Cargando...</span>
              </div>
            ) : (
              Array.isArray(detalles) && detalles.length > 0 ? (
                detalles.map(detalle => (
                  <div key={detalle.IdItem}>

                    {copiado && (
                      <div style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        backgroundColor: '#333',
                        color: '#fff',
                        padding: '10px 15px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                        zIndex: 9999
                      }}>
                        ¡Link copiado al portapapeles!
                      </div>
                    )}

                    <h5>Actividad: {detalle.Articulo} - Cantidad: {detalle.CantidadParticipantes} - Cargados: {detalle.CantidadParticipantesCargados} - Inicio: {FormateoFechaPara_ddMMyyyy_HHmm(new Date(detalle.FechaReservaInicio))}</h5>
                    {reserva.EsEvento && <h5></h5>}
                    {reserva.EsEvento && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <h5>
                          EVENTO - LINK PARA PADRES DE ESTE EVENTO:{" "}
                          https://neftis.com.ar/cumple.html?IdReserva={reserva.IdReserva}&IdItem={detalle.IdItem}&CodigoCompania={localStorage.getItem("CodigoCompania")}
                        </h5>

                        <button
                          onClick={() => {
                            const link = `https://neftis.com.ar/cumple.html?IdReserva=${reserva.IdReserva}&IdItem=${detalle.IdItem}&CodigoCompania=${localStorage.getItem("CodigoCompania")}`;
                            navigator.clipboard.writeText(link);
                            setCopiado(true);
                            setTimeout(() => setCopiado(false), 2500); // lo esconde a los 2.5 segundos
                          }}
                          style={{ padding: '5px 10px', cursor: 'pointer' }}
                        >
                          COPIAR
                        </button>
                      </div>
                    )}

                    <VEN_Reservas_ParticipantesPorItem
                      Reserva={reserva}
                      IdItemSeleccionado={detalle.IdItem}
                      IdClienteResponsable={idClienteResponsable}
                    />

                    <hr style={{ borderColor: 'white', borderWidth: '1px' }} />

                  </div>
                ))
              ) : (
                <div>La Reserva no existe.</div>
              )
            )}
          </div>
        </SimpleItem>

        <SimpleItem colSpan={10}>
          <LVButtonReporte Ancho="100%" Texto="IR A PUNTO DE VENTA" Url={`/VEN_PuntoDeVenta_/${localStorage.getItem("Terminal")}`} />
        </SimpleItem>
      </LVForm>
    </PaginaCarga>
  );
};
